import { useModalState } from 'src/hooks/useModalState'
import { Modal } from 'antd'
import React, { useEffect, useRef } from 'react'
import styles from 'src/styles/BannerNotify.module.scss'
import { getUserId, isShowScheduleNotificationModal, markScheduleModalAsShown } from 'src/libs/browser'
import Link from 'next/link'
import { useGetData } from 'src/hooks/useGetData'
import userApi from 'src/api/userApi'
import { getInfo } from 'src/libs/util'

const links = [
  {
    key: 'monthly',
    title: 'Xem kịch bản thi tháng',
    link: 'https://docs.google.com/spreadsheets/d/1rTXWqcTeg42R9viJ5V2Wd8WX5fldBcRWaDF3R2Zpdss/edit?gid=0#gid=0'
  },
  {
    key: 'openingCeremony',
    title: 'Xem kịch bản khai giảng',
    link: 'https://docs.google.com/document/d/1vHTStD40C5aHsLvDU08YWuGnn68B_5nr/edit'
  }
]

const ModalBannerNotifyCalendar = () => {
  const { isModalVisible, handleClose, handleOpen } = useModalState()
  const id = getUserId()
  const { data: user } = useGetData(userApi.detail, id, { isDisabled: !id })
  const { classType } = getInfo(user?.userInfoData)
  const hasShownOnceRef = useRef(false) // Flag để chỉ show modal 1 lần trong session

  useEffect(() => {
    // Nếu classType chưa sẵn sàng thì bỏ qua, khi nào sẵn sàng sẽ tự động chạy lại
    if (!classType || !Array.isArray(classType)) {
      return
    }

    // Nếu đã show modal lần này rồi thì không show lại
    if (hasShownOnceRef.current) {
      return
    }

    const shouldShowModal = isShowScheduleNotificationModal()
    const hasValidClassType = classType.includes('REGULAR') || classType.includes('BACKUP')

    if (shouldShowModal && hasValidClassType) {
      // Set cookie NGAY LẬP TỨC, không dùng setTimeout
      markScheduleModalAsShown()
      hasShownOnceRef.current = true
      handleOpen()
    }
  }, [classType])

  const handleCloseModal = () => {
    handleClose()
  }
  return (
    <Modal
      visible={isModalVisible}
      destroyOnClose
      width={1180}
      footer={null}
      closable={false}
      wrapClassName='banner-notify'
      bodyStyle={{ padding: 0 }}
    >
      <div className={styles.banner_container}>
        <div
          className={styles.btn_close}
          onClick={handleCloseModal}
        >
          <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path
              fillRule='evenodd' clipRule='evenodd'
              d='M4.01161 4.01161C4.55835 3.46488 5.44478 3.46488 5.99151 4.01161L12.0016 10.0217L18.0116 4.01161C18.5583 3.46488 19.4448 3.46488 19.9915 4.01161C20.5382 4.55835 20.5382 5.44478 19.9915 5.99151L13.9815 12.0016L19.9915 18.0116C20.5382 18.5583 20.5382 19.4448 19.9915 19.9915C19.4448 20.5382 18.5583 20.5382 18.0116 19.9915L12.0016 13.9815L5.99151 19.9915C5.44478 20.5382 4.55835 20.5382 4.01161 19.9915C3.46488 19.4448 3.46488 18.5583 4.01161 18.0116L10.0217 12.0016L4.01161 5.99151C3.46488 5.44478 3.46488 4.55835 4.01161 4.01161Z'
              fill='#6B7280'
            />
          </svg>
        </div>
        <div className={styles.banner_body_content}>
          <img src='/image/banner_remind_monthly.png' alt='banner' className='img-fluid d-block mx-auto' />
          <div className={styles.content_text}>
            <p className='mb-24'>Từ ngày 23/02/2026, các lớp <strong>Edupia Pro 2.0</strong> bước vào hành trình mới — nơi mỗi buổi học là
               một bước tiến rõ
               ràng của học sinh.</p>
            <p className='mb-24'>Thầy/Cô vui lòng <strong>kiểm tra ngay lịch dạy hôm nay và triển khai lớp theo kịch bản khai giảng</strong> để đảm bảo
               khởi động đồng bộ, trọn vẹn trải nghiệm cho học sinh.</p>
            <div className='mb-24'>
              <span>📌 Lưu ý trong buổi học:</span>
              <ul>
                <li>Nhắc nhở học sinh hoàn thành <strong>kỳ thi tháng 2</strong></li>
                <li>Hướng dẫn bài thi <strong>Speaking (thi nói)</strong> hàng tháng</li>
                <li>Triển khai <strong>kịch bản khai giảng chuẩn 3 bước "Let's connect!"</strong></li>
              </ul>
            </div>
            <p>⏰ <strong style={{color: '#A72B2B'}}>Vui lòng hoàn tất chuẩn bị trước giờ học ngay nhé.</strong></p>
          </div>
          <div className={styles.box_link}>
            {links.map(link => (
              <Link href={link.link} key={link.key}>
                <a target='_blank' className={styles.link_guide}>{link.title}</a>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </Modal>
  )
}
export default ModalBannerNotifyCalendar
